import { SnowplowService } from 'wanderu-service-analytics';

function addTravelerDropdownClicked({ itineraryId, travelers, wheelchairs }) {
    SnowplowService.fireStructuredEventWithBatchId({
        category: 'react_tripsummary',
        action: 'expand',
        label: 'add_traveler',
        property: {
            itinerary_id: itineraryId,
            travelers,
            wheelchairs,
        },
    });
}

function updateTravelerButtonClicked({ itineraryId, travelers, increase }) {
    SnowplowService.fireStructuredEventWithBatchId({
        category: 'react_tripsummary',
        action: 'click',
        label: increase
            ? 'add_traveler'
            : 'subtract_traveler',
        property: {
            itinerary_id: itineraryId,
            travelers,
        },
    });
}

function updateWheelchairSeatButtonClicked({ itineraryId, wheelchairs, increase }) {
    SnowplowService.fireStructuredEventWithBatchId({
        category: 'react_tripsummary',
        action: 'click',
        label: increase
            ? 'add_wheelchair'
            : 'subtract_wheelchair',
        property: {
            itinerary_id: itineraryId,
            wheelchairs,
        },
    });
}

export default {
    addTravelerDropdownClicked,
    updateTravelerButtonClicked,
    updateWheelchairSeatButtonClicked,
};
